<template>
  <div class="flex items-center py-4 px-6 cursor-pointer
              text-text-secondary
              transition duration-200 hover:bg-highlight hover:text-text"
       :class="{selected}"
       @click="$emit('selectAcc',item)">
    <MKIcons :icon="item.icon"
             class="w-10 h-10 -my-2 mr-4 text-md flex items-center"
             :style="`color:${item.icon_color};background:${item.icon_bg}`"/>
    <div class="text-sm flex-1 truncate">{{ item.title }}</div>
    <div class="text-2sm ml-auto font-normal"
         :class="balanceClass"
         v-tooltip="balanceTooltip"
         v-html="parseBalance(item)"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MKIcons from "@/components/icons/MKIcons/MKIcons";

export default {
  name: "MyAccountsItem",
  components: {MKIcons},
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    balanceTooltip() {
      let accountCurrencyIsDifferentFromSpace = this.item.currency.id !== this.spaceInfo.currency.id;
      if (accountCurrencyIsDifferentFromSpace) {
        return this.displayCurrencyValue(this.item.balance_base, this.spaceInfo.currency, true)
      }
      return null
    },
    balanceClass() {
      let decimals = this.item.currency,
          balance = this.item.balance.toFixed(decimals);
      return balance < 0 ? 'text-red' : ''
    },
  },
  methods: {
    parseBalance(account) {
      let currency = account.currency,
          formattedBalance = this.displayCurrencyValue(account.balance, currency, false),
          intPart = formattedBalance.split('.')[0],
          decimalPart = formattedBalance.split('.')[1];
      //splitting value to apply css rules
      return `${intPart}<span class="opacity-40">.${decimalPart}</span> <span class="text-text-secondary">${currency.symbol}</span>`
    }
  }
}
</script>

<style scoped>
.selected {
  @apply text-text bg-highlight;
}
</style>